#import "../../../../../../common/graphql/NotesEntityFields.graphql"

query ListCardHolderNotes($id: UUID!) {
  cardHolder(id: $id) {
    id
    notesByEntityId(orderBy: _CREATED_DATE_DESC) {
      nodes {
        ...NotesEntityFields
      }
    }
  }
}
